import { TransformedWebProjectModel, WebProjectItemModel } from "./types";
import { useWindowManager } from "./WindowManager";
import { calculateCenterPosition, getRandomWindowPosition } from "./utils";
import EmbeddedBrowser from "../components/EmbeddedBrowser/EmbeddedBrowser";
import ProjectDetailsWindow from "../../../components/ProjectDetailsWindow/ProjectDetailsWindow";
import defaultIcon from "../../../assets/images/html-5-icon.png";

export const getProjectIcon = (project: WebProjectItemModel) =>
  project.icon?.url || defaultIcon;

export const toTransformedProject = (
  project: WebProjectItemModel
): TransformedWebProjectModel => ({
  ...project,
  addressBarLink: project.link,
  showAddressBar: true,
  showBottomBar: true,
  component: (
    <EmbeddedBrowser link={project.link} height="500px" width="700px" />
  ),
});

// Opening a project (live site in a browser window) or its details window,
// shared by the desktop icons, folders, My Computer and System Properties.
export const useOpenProject = () => {
  const { openWindow } = useWindowManager();

  const openProject = (project: WebProjectItemModel) => {
    const transformed = toTransformedProject(project);
    openWindow({
      windowTitle: transformed.title,
      component: transformed.component,
      isMaximized: false,
      isMinimized: false,
      icon: getProjectIcon(project),
      showAddressBar: transformed.showAddressBar,
      addressBarLink: transformed.addressBarLink,
      showBottomBar: transformed.showBottomBar,
      position: getRandomWindowPosition(calculateCenterPosition(400, 300)),
      size: {
        width: 10,
        height: 10,
      },
    });
  };

  const openProjectDetails = (project: WebProjectItemModel) => {
    openWindow({
      windowTitle: project.title + " Details",
      isMinimized: false,
      isMaximized: false,
      component: (
        <ProjectDetailsWindow project={toTransformedProject(project)} />
      ),
      position: getRandomWindowPosition(calculateCenterPosition(400, 300)),
      icon: getProjectIcon(project),
    });
  };

  return { openProject, openProjectDetails };
};
